import { AppConfig } from "@constants/AppConfig.ts"

export const generateAppEntity = (entityName: string) =>
	`${AppConfig.APP_ID}_${entityName}`
